module.exports = __webpack_public_path__ + "static/media/51.f997027f.jpg";